var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg001(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9585 0.833252C1.78489 0.833252 0.833496 1.78465 0.833496 2.95825C0.833496 4.13186 1.78489 5.08325 2.9585 5.08325H27.0418C28.2154 5.08325 29.1668 4.13186 29.1668 2.95825C29.1668 1.78465 28.2154 0.833252 27.0418 0.833252H2.9585ZM27.7502 7.20825H2.25016V20.6666C2.25016 22.2314 3.51869 23.4999 5.0835 23.4999H13.9377V29.1666C13.9377 29.7534 14.4134 30.2291 15.0002 30.2291C15.587 30.2291 16.0627 29.7534 16.0627 29.1666V23.4999H24.9168C26.4816 23.4999 27.7502 22.2314 27.7502 20.6666V7.20825ZM21.5779 12.7134C21.8798 12.2102 21.7166 11.5576 21.2135 11.2557C20.7103 10.9538 20.0576 11.1169 19.7557 11.6201L18.2225 14.1754C17.6989 15.0481 16.4656 15.1311 15.8298 14.3363C14.269 12.3853 11.2411 12.5889 9.95558 14.7315L8.4224 17.2868C8.12049 17.7899 8.28365 18.4426 8.78683 18.7445C9.29001 19.0464 9.94266 18.8832 10.2446 18.3801L11.7778 15.8248C12.3014 14.9521 13.5347 14.8691 14.1705 15.6638C15.7313 17.6149 18.7592 17.4112 20.0447 15.2687L21.5779 12.7134Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001);
export default __webpack_public_path__ + "static/media/001.00ec1ed9e8533eb9a61e7cb56df60b6d.svg";
export { ForwardRef as ReactComponent };